/// <reference path='../../interfaces/interfaces.d.ts' />
import functions = require('../../global/functions');

'use strict';


class ProcessEditController {
    public static $inject = [
        '$scope',
        '$state',
        '$uibModal',
        'Orgs',
        'User',
        'Employee',
        'Process',
        'bsLoadingOverlayService',
        'toaster',
        '$q',
        'Upload',
    ];

    public def;
    public form;
    public leaveBalance;
    public leaveUsed;
    public leaveError;
    public leaveWarning;
    public org;
    public employee;
    public isAdmin = false;
    public emp_can_view;
    public leave_config: {
        leave_start_date: any
        paid_leave_days_per_year?: number
        maternity_leave_days_per_year?: number
        sick_leave_days_per_year?: number
        carried_forward?: number
        work_days: number[]
    };
    public holidays;
    public org_schema;
    public transitionForm;
    public _path;
    public support_email;
    public hasDate;
    public process;

    // model obj for doc leave and expense request forms
    public doc_process = {
        addressee: undefined,
        purpose: undefined,
        type: undefined
    };

    public leave_process = {
        type: undefined,
        start_date: undefined,
        end_date: undefined,
        file: undefined,
        note: undefined,
        half_day: false
    };

    public expense_process = {
        amount: undefined,
        date: undefined,
        description: undefined,
        invoice: undefined,
        title: undefined,
        type: undefined
    };
    // drop down arrays for the different request
    public document_types = ['NOC', 'salary certificate', 'reference letter', 'Other'];
    public expense_types = ['Travel', 'Fuel', 'Parking', 'Salik', 'Food', 'Entertainment', 'Client Expenses', 'Reimbursement', 'Other'];
    public leave_types = ['paid', 'unpaid', 'sick', 'maternity', 'paternity', 'compassionate', 'work from home'];

    constructor(
        private $scope: any,
        private $state: ng.ui.IStateService,
        private $uibModal: any,
        private Org: IOrgsService,
        private User: IUserService,
        private Employee: IEmpService,
        private Process: IProcessService,
        private bsLoadingOverlayService: IBsLoadingService,
        private toaster: toaster.IToasterService,
        private $q: angular.IQService,
        private Upload: any) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;

        bsLoadingOverlayService.start({ referenceId: 'loader'});
        // detect the type of request you are making through the state params
        // _.assign(this.process.extra.transitions[0].data, $state.params['data']);
        // assign the employee ID to the trasition step
        // this.process.extra.transitions[0].data.employee = $state.params['employee_id'] || '';
        this.isAdmin = User.getCurrentUser().userData.user.clearance === 'admin';

        this.Org.getOrgFromCache((response) => {
            this.org = response;
            this.Org.loadSchema().then((r) => {
                this.org_schema = r.data;
                this.checkLoading();
            });
        });


        Process.loadProcess($state.params['id'])
            .then((response: any) => {
                this.process = response;
           //load employee from transitions data
           this.Employee.loadEmployee(this.process.extra.transitions[0].employee).then((response) => {
            this.employee = response;            
            this.checkLoading();
        });


                // check if the process has a start date
                if (this.process.extra && this.process.extra.data && this.process.extra.data.start_date) {
                    this.hasDate = true;
                }
                if (this.process.type == 'leave') {
                    this.leave_process.type = this.process.extra.data['type'];
                    this.leave_process.start_date = moment(this.process.extra.data['start_date'], 'YYYY-MM-DD').toDate();
                    this.leave_process.end_date = moment(this.process.extra.data['end_date'], 'YYYY-MM-DD').toDate();
                    if (this.process.extra.data['note']) {
                        this.leave_process.note = this.process.extra.data['note'];
                    }
                    if (this.process.extra.data['file']) {
                        this.leave_process.file = this.process.extra.data['file'];
                    }
                    if (this.process.extra.data['half_day']) {
                        this.leave_process.half_day = this.process.extra.data['half_day'];
                    }
                    this.leaveBalance = NaN;
                    this.leaveUsed = NaN;
                    this.$scope.leaveUsed = 0;
                    this.$scope.leaveBalanceNextYear = 0;
                    this.$scope.leaveUsedThisYear = 0;
                    this.$scope.leaveUsedNextYear = 0;
                    this.$scope.allowHalfDayLeave = false;
                    this.$scope.spanYear = false;

                }

                Process.getDef(this.process.type).then((def) => {
                    this.def = def;
                    this.checkLoading();
                });

                // bsLoadingOverlayService.stop({referenceId: 'requests_loader'});
        },
        () => {
            this.toaster.pop('error', 'Server error', 'Process cannot be loaded');
        });


        this.Employee.getSupportEmail().then((response) => {
            this.support_email = response;
        });
        this.form = ['*'];
    }

    private checkLoading(): void {
        if (this.def && this.employee && this.org && this.org_schema ) {
            this.bsLoadingOverlayService.stop({ referenceId: 'loader'});
            // set the process step for the green boxes
            this.Process.getPath(this.process.type, 'init', this.def.path_to_success).then((path) => {
                this._path = path;
            });
            // get leave config for the requesting user
            this.leave_config = functions.get_leave_config(this.employee, this.org, this.org_schema);
            this.$scope.leave_process = this.leave_process;

            let allowHalfday: any = () => {
                // Only process if start and end dates have been filled in
                if (!this.leave_process.start_date || !this.leave_process.end_date) {
                    return false;
                }

                return this.leave_process.start_date.getTime() === this.leave_process.end_date.getTime();
            };

            if (this.process.type === 'leave') {
                // this watch() only applies to the leave type, you only need to run these calculations if you are requesting leave
                this.$scope.$watch('leave_process', (newValue, oldValue, scope) => {
                    let type: any = this.leave_process.type;
                    if (!type) {
                        return;
                    }

                    this.leaveError = this.validate_leave();
                    if (this.leaveError !== '') {
                        return;
                    }

                    //TODO: leave
                    // unpaid leave does not need a leave balance calculation
                    if ((type !== 'paid' && type !== 'sick' && type !== 'maternity' && type !== 'paternity')) {
                        return;
                    }

                    // Only process if start and end dates have been filled in
                    if (!this.leave_process.start_date || !this.leave_process.end_date) {
                        return;
                    }

                    this.$scope.allowHalfDayLeave = allowHalfday();
                    if (!this.$scope.allowHalfDayLeave) {
                        // Uncheck a ticked half-day leave checkbox
                        this.leave_process.half_day = false;
                    }


                    let start: any = undefined;
                    let end: any = undefined;
                    if (this.leave_process.start_date && this.leave_process.end_date) {
                        start = moment(this.leave_process.start_date);
                        end = moment(this.leave_process.end_date);
                    }
                    // check leave balance here
                    this.leave_balance().then((response: any) => {
                            this.$scope.leaveBalance = response.data['leave_balance'];
                            this.$scope.leaveBalanceNextYear = response.data['leave_balance_next_year'];
                            this.$scope.leaveUsed = response.data['leave_used'];
                            this.$scope.leaveUsedThisYear = response.data['leave_used_this_year'];
                            this.$scope.leaveUsedNextYear = response.data['leave_used_next_year'];
                            this.$scope.spanYear = response.data['span_cycle'];

                            // If an existing leave booking overlaps, allow admins to submit the request
                            // Non-admins can't submit double booked request
                            if (response.data['has_existing_booked_leave']) {
                                if (this.isAdmin) {
                                    this.leaveWarning = response.data['existing_leave_message'];
                                } else {
                                    this.leaveError = response.data['existing_leave_message'];
                                }
                            }

                            if (this.$scope.leaveBalance < 0) {
                                this.$scope.negativeLB = true;
                            }
                        }, (response: any) => {
                            if (!response) {
                                this.leaveBalance = NaN;
                            } else if (response.status === 400) {
                                this.toaster.pop('error', 'Validation Failed', response.data[0]);
                                this.leaveBalance = NaN;
                            } else {
                                this.toaster.pop('error', 'Server Error', response.data.detail);
                                this.leaveBalance = NaN;
                            }
                        }
                    );
                }, true);
            }
        }
    }

    // convert form obj to be compatible for the onj that need to be sent back to the backend
    // if() cleans the fields that are not filled out so that the backend does not get empty fields
    public handle_data(request_type: any): any {
        switch (request_type) {
            case 'document':
                this.process.extra.transitions[0].data['addressee'] = this.doc_process.addressee;
                this.process.extra.transitions[0].data['purpose'] = this.doc_process.purpose;
                this.process.extra.transitions[0].data['type'] = this.doc_process.type;
                break;
            case 'leave':
                this.process.extra.transitions[0].data['type'] = this.leave_process.type;
                this.process.extra.transitions[0].data['start_date'] = moment(this.leave_process.start_date).format('YYYY-MM-DD');
                this.process.extra.transitions[0].data['end_date'] = moment(this.leave_process.end_date).format('YYYY-MM-DD');
                // console.log((this.leave_process.note));
                if (this.leave_process.note) {
                    this.process.extra.transitions[0].data['note'] = this.leave_process.note;
                }
                if (this.leave_process.file) {
                    this.process.extra.transitions[0].data['file'] = this.leave_process.file;
                }
                if (this.leave_process.half_day) {
                    this.process.extra.transitions[0].data['half_day'] = this.leave_process.half_day;
                }
                break;
            case 'expense':
                this.process.extra.transitions[0].data['date'] =  moment(this.expense_process.date).format('YYYY-MM-DD');
                this.process.extra.transitions[0].data['title'] = this.expense_process.title;
                this.process.extra.transitions[0].data['amount'] = this.expense_process.amount;
                if (this.expense_process.invoice) {
                    this.process.extra.transitions[0].data['invoice'] = this.expense_process.invoice;
                }
                if (this.expense_process.description) {
                    this.process.extra.transitions[0].data['description'] = this.expense_process.description;
                }
                if (this.expense_process.type) {
                    this.process.extra.transitions[0].data['type'] = this.expense_process.type;
                }
                break;
            default:
        }
        this.sendProcess();
    }

    // sends the requests to the backend
    public sendProcess(): void {
        let that = this;
        if (this.process) {
            // sends the correct model obj back and creates the request process
            let saveProcess: any = () => {
                this.bsLoadingOverlayService.start({ referenceId: 'loader'});
                this.process.put().then((response) => {
                    this.bsLoadingOverlayService.stop({ referenceId: 'loader'});
                    this.toaster.pop('success', 'Saved');
                    this.$state.go('^', {}, {reload: true});
                }, (response) => {
                    this.bsLoadingOverlayService.stop({ referenceId: 'loader'});
                    this.toaster.pop('error', response.data);
                });
            };
            // stops the request if there is a validation error
            if (this.process.type === 'leave') {
                if (this.leaveError) {
                    this.toaster.pop('warning', 'Validation Failed', this.leaveError);
                    return;
                }
                // checking for negative leave request and gives warning
                if (this.leaveBalance < 0) {
                    let modal_instance: any = this.$uibModal.open({
                        templateUrl: '/static/templates/modals/request_leave_warning_modal.html',
                        controller: ['$scope', '$uibModalInstance', 'toaster', ($scope, $uibModalInstance, toaster) => {
                            $scope.ok = () => { saveProcess(); $uibModalInstance.close(); };
                        }],
                    });
                } else {
                    saveProcess();
                }
            } else if (this.process.type === 'warning') {
                if (!this.emp_can_view) {
                    this.process.type = 'hidden_warning';
                }
                saveProcess();
            } else {
                saveProcess();
            }
        } else {
            this.toaster.pop('warning', 'Validation Failed', 'Please check the form.');
        }
    }

    public leave_balance(): ng.IPromise<any> {
        let start_date: any = undefined;
        if (this.leave_process.start_date) {
            start_date = moment(this.leave_process.start_date).format('YYYY-MM-DD');
        }
        let end_date: any = undefined;
        if (this.leave_process.end_date) {
            end_date = moment(this.leave_process.end_date).format('YYYY-MM-DD');
        }
        let half_day: boolean = this.leave_process.half_day;
        let leave_type: any = this.leave_process.type;
        let emp_id: any = this.employee.id;
        if (!start_date || !end_date || !leave_type) {
            return this.$q.reject();
        }
        let leaves_item: any = {type: leave_type, start_date: start_date, end_date: end_date, half_day: half_day};
        return this.Employee.postLeaveBalanceCheck(emp_id, leaves_item);
    }

    public validate_leave(): string {
        let type: any = this.leave_process.type;
        if ((type === 'paid' || type === 'sick' || type === 'maternity' || type === 'paternity')) {
            if (!this.leave_config.leave_start_date) {
                return 'Your employment contract start date has not been set - unable to calculate leave balance';
            }
        }
        let start: any = undefined;
        if (this.leave_process.start_date) {
            start = moment(this.leave_process.start_date);
        } else {
            return 'You need to specify a From date';
        }
        let end: any = undefined;
        if (this.leave_process.end_date) {
            end = moment(this.leave_process.end_date);
        } else {
            return 'You need to specify a To date';
        }
        let today: Moment = moment({hour: 0});
        if (start && start.diff(end, 'days') !== 0 && this.leave_process.half_day) {
            return 'Start date and end date has to be the same to request a half day leave';
        }
        if (!this.User.getCurrentUser().isSuperUserMask) {
            if (start && type === 'paid' && start.diff(today, 'days') < 0) {
                return 'Start date must be today or after';
            }
        }
        if (end && end.isBefore(start)) {
            return 'End date must not be before start date';
        }
        return '';
    }

    public hasSuperiorAndPermission(): boolean {
        if (this.User.getCurrentUser().userData.superior === null && this.User.hasPermission('org.change_org')) {
            return false;
        }
        return true;
    }

    public uploadFiles = function(params: any): any {
        let that: any = this;
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        let file: any = params.new;
        let model: any = params.fileType;
        this.Upload.upload({
            url: '/api/uploads/other',
            method: 'POST',
            data: {file: params.new}
        }).then(
            (response) => {
                // upload the doc based on the request type
                if (params.fileType === 'expense_process') {
                    that.expense_process.invoice = response.data.url;
                } else {
                    that.leave_process.file = response.data.url;
                }
                this.toaster.pop('success', 'upload successful', '');
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            },
            (response) => {
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                this.toaster.pop('error', 'upload failed', '');
            }
        );
    };
}

angular.module('beneple.process')
    .controller('ProcessEditController', ProcessEditController);



// WEBPACK FOOTER //
// ./frontend/scripts/process/controllers/process_edit.controller.ts